import { THeaders } from '../../../types/request';
import { fetchCheckPayment } from '../../../repositories/billing-payments/v3/check-payment';
import { mappers } from './mappers';
import { IGetYandexPaymentStatusDependencies, IYandexPaymentStatus, EYandexPaymentStatus } from './types';

export const getYandexPaymentStatus = async (dependencies: IGetYandexPaymentStatusDependencies) => {
  const { httpApi, logger, parameters } = dependencies;

  const config = {
    requestConfig: {
      headers: [['Content-Type', 'application/json']] as THeaders,
    },
  };

  try {
    return await fetchCheckPayment<IYandexPaymentStatus, IYandexPaymentStatus>({
      httpApi,
      parameters,
      config,
      mappers,
    });
  } catch (error) {
    if (error.type !== 'TimeoutError') {
      logger.error(
        error,
        {
          description: 'Billing-payments v3/check-payment rejection error',
          degradation: 'Пользователь запросил статус платежа, но сервер не смог его обработать',
          requestParameters: { ...parameters },
        },
        );
    }

    return Promise.resolve({ status: EYandexPaymentStatus.PENDING });
  }
};
